import { render } from "./ForumMenu.vue?vue&type=template&id=5a1756a4&scoped=true"
import script from "./ForumMenu.vue?vue&type=script&scoped=true&lang=js"
export * from "./ForumMenu.vue?vue&type=script&scoped=true&lang=js"

import "./ForumMenu.vue?vue&type=style&index=0&id=5a1756a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1756a4"]])

export default __exports__